import { render } from "./FailedEmails.vue?vue&type=template&id=37c5b39a"
import script from "./FailedEmails.vue?vue&type=script&lang=js"
export * from "./FailedEmails.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__